import axios from 'axios'

export const showFreeShippingBar = () => {
  const cartPage = document.querySelector('[data-cart-geo-target]');
  const freeShippingBar = document.querySelector('[data-country-show-gb]')
  const freeShippingBarInt = document.querySelector('[data-country-show-int]')

  if (cartPage) {
    if (freeShippingBar || freeShippingBarInt) {
      axios.get('/browsing_context_suggestions.json').then(res => {
        if (res.data && res.data.detected_values) {
          if (res.data.detected_values.country.handle === 'GB') {
            freeShippingBarInt.classList.add('hide')
            freeShippingBar.classList.add('show')
          } else {
            freeShippingBar.classList.add('hide')
            freeShippingBarInt.classList.add('show')
          }
        }
      })
    }
  }
}
